// Uyarlanmış kopya — emsal: beltasapp/frontend/src/shared/ui/izgara/izgara-geri-al.ts
// Fark: derinlik 100; yığın girdisi satır anlık görüntüsü + etkilenen alan taşır (geri alınca seçim oraya döner).

/** Undo/redo depth. */
export const UNDO_LIMIT = 100

export interface History<S> {
  /** Pushes the state BEFORE an operation. A new operation drops the redo branch. */
  push: (state: S) => void
  /**
   * Ctrl+Z. Pops the last pushed state and returns it; `current` builds the state to put on the
   * redo stack from the popped entry (so redo knows the same affected area). Empty = undefined.
   */
  undo: (current: (popped: S) => S) => S | undefined
  /** Ctrl+Y / Ctrl+Shift+Z: the mirror of `undo`. */
  redo: (current: (popped: S) => S) => S | undefined
  clear: () => void
  size: () => { undo: number; redo: number }
}

export function createHistory<S>(limit = UNDO_LIMIT): History<S> {
  const back: S[] = []
  const forward: S[] = []
  const capped = (stack: S[], state: S) => {
    stack.push(state)
    if (stack.length > limit) stack.shift()
  }
  return {
    push(state) {
      capped(back, state)
      forward.length = 0
    },
    undo(current) {
      const popped = back.pop()
      if (popped === undefined) return undefined
      capped(forward, current(popped))
      return popped
    },
    redo(current) {
      const popped = forward.pop()
      if (popped === undefined) return undefined
      capped(back, current(popped))
      return popped
    },
    clear() {
      back.length = 0
      forward.length = 0
    },
    size: () => ({ undo: back.length, redo: forward.length }),
  }
}
